import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Segment, Message, Icon, Card, Label } from 'semantic-ui-react';
import JsonapiClient from '@holidayextras/jsonapi-client';
import _ from 'lodash';
import axios from 'axios';
import moment from 'moment';
import ConfirmationModal from '../../components/confirmation-modal';
import ThemeSelector from '../../themes/theme-selector';
import { authService } from '../../utils/auth-service';
import hasUserInfo from '../../hocs/has-user-info';

class Shortlists extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      lists: [],
      confirmOpen: false,
    };

    this.jsonClient = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
      header: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }

  componentDidMount = () => {
    const { userInfo } = this.props;
    this.restClient = axios.create({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      timeout: 2000,
      headers: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
    if (userInfo) this.getShortlists(userInfo);
  }

  getShortlists = userInfo => {
    const { organisationId } = userInfo;
    if (!organisationId) return;
    const options = {
      filter: {
        organisation: organisationId,
      },
      sort: '-createdDate',
    };

    this.jsonClient.find('shortlists', options)
      .then(lists => {
        const listsJson = _.map(lists, list => list.toJSONTree());
        this.setState({
          lists: listsJson,
          loading: false,
        });
      });
  }

  queueDelete = (e, { value }) => {
    this.setState({
      toBeDeleted: value.id,
      confirmOpen: true,
      shortlistName: value.name,
    });
  }

  deleteLink = () => {
    const value = this.state.toBeDeleted;
    const url = `/shortlists/${value}`;

    this.restClient.delete(url).then(() => {
      const { lists } = this.state;
      _.remove(lists, {
        id: value,
      });

      this.setState({
        confirmOpen: false,
        lists,
      });
    });
  }

  handleCancel = () => {
    this.setState({
      toBeDeleted: null,
      confirmOpen: false,
    });
  }

  render() {
    const { loading, lists, confirmOpen, shortlistName } = this.state;
    const { userInfo } = this.props;
    const organisationName = _.get(userInfo, 'organization.name');
    const shortlistFAQ = 'http://help.dyzio.co/getting-started/influencer-shortlists';
    const segmentStyles = { margin: 0, padding: 0 };
    const blackText = { color: '#000' };

    const isFullWhiteLabel = ThemeSelector.isFullWhiteLabel();

    const getDeleteButton = (list, handleDelete) => (
      <Button
        floated="right"
        icon="delete"
        circular
        inverted
        color="pink"
        value={list}
        content="delete"
        onClick={handleDelete}
      />
    );

    const getStatusLabel = list => (
      <Label>{list.status}</Label>
    );

    return (
      <div className="page">

        <div style={{ height: 140, backgroundColor: '#FFF', borderBottom: '1px solid #EEE' }}>
          <div className="page-hero">
            <h1 style={{ paddingTop: 40 }}>Shortlists</h1>
            <h4 className="light">{organisationName}</h4>
          </div>
        </div>

        <div className="page-content">

          <Message icon>
            <Icon name="info" color="teal" />
            <Message.Content>
              <Message.Header>Go to &apos;My Influencers&apos; to create a Shortlist</Message.Header>
              <br />
              <p>Select influencers from your private database and then click add to shortlist.</p>

              {
                !isFullWhiteLabel &&
                <p>Check out our <strong>FAQ</strong> if you get stuck <a
                  href={shortlistFAQ} rel="noopener noreferrer"
                  target="_blank"
                >{shortlistFAQ}</a></p>
              }

            </Message.Content>
          </Message>

          <Segment loading={loading} basic style={segmentStyles}>

            {
              !loading && lists.length === 0 &&
              <Card fluid>
                <Card.Content>
                  <Card.Header>
                    No shortlists yet!
                  </Card.Header>
                </Card.Content>
                <Card.Content>
                  <p>check out our <strong>FAQ</strong> to get you started
                  &nbsp;<a href={shortlistFAQ} rel="noopener noreferrer" target="_blank">{shortlistFAQ}</a></p>
                  <p>
                    <strong>hint: </strong>
                    You need to head over to My Influencers and select some influencers first!
                  </p>
                </Card.Content>
              </Card>
            }

            { _.map(lists, list => {
              const deleteButton = getDeleteButton(list, this.queueDelete);
              const statusLabel = getStatusLabel(list);
              const shortlistedInfuencers = _.uniqBy(list.influencers, 'id');
              return (
                <Card fluid key={list.id}>
                  <Card.Content>
                    <Card.Header>
                      {deleteButton}
                      <a href={`/shortlists/${list.id}`} style={blackText}>{list.name}</a>
                    </Card.Header>
                    <Card.Meta>
                      Created by {list.createdBy} on {moment(list.createdDate).format('DD MMM YYYY')}
                    </Card.Meta>
                  </Card.Content>
                  <Card.Content>
                    <div dangerouslySetInnerHTML={{ __html: list.notes }} />
                  </Card.Content>
                  <Card.Content extra>
                    {statusLabel}
                    <Icon name="user" color="pink" />
                    {shortlistedInfuencers.length} Influencers
                  </Card.Content>
                </Card>
              );
            })
            }

          </Segment>
          { confirmOpen && <ConfirmationModal
            bodyText={`Are you sure you want to delete shortlist '${shortlistName}'?`}
            onCancel={this.handleCancel}
            onConfirm={this.deleteLink}
          />
          }
        </div>
      </div>
    );
  }
}

Shortlists.propTypes = {
  userInfo: PropTypes.object.isRequired,
};

export default hasUserInfo(Shortlists);



/** WEBPACK FOOTER **
 ** ./src/containers/shortlists/index.js
 **/